import React from "react";

const WelcomeMessage: React.FC = () => {
  const services = [
    "Custom Itinerary",
    "Hotels & Vacation Rentals",
    "Restaurants & Bars",
    "Tours & Short Trips",
    "Travel Safety",
    "Best Routes",
    "Local Customs & Slang",
    "Visas",
  ];

  return (
    <div className="text-[#898989]">
      <p className="mb-2">
        Hello! I'm your AI Travel Planner. I can help you with:
      </p>
      <ul className="mb-2 space-y-1 ml-1 text-base">
        {services.map((service, index) => (
          <li key={index}>• {service}</li>
        ))}
      </ul>
      <p>
        I'm proficient in 45 languages. Feel free to ask me any travel-related
        questions!
      </p>
    </div>
  );
};

export default WelcomeMessage;
